import { BodyText } from '@/components/BodyText';
import { Close } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';

export const FilterSectionHeader = ({
  title,
  hasSelectedFilters,
  onClearAll,
}: {
  title: string;
  hasSelectedFilters?: boolean;
  onClearAll?: () => void;
}) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      marginTop: '8px',
      marginBottom: '2px',
    }}
  >
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 8px 0 0' }}>
      <BodyText color='text.secondary'>{title}</BodyText>
      {hasSelectedFilters && (
        <Tooltip title={`Clear all ${title.toLowerCase()}`}>
          <Box
            component='button'
            onClick={onClearAll}
            sx={{
              color: 'text.secondary',
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: '12px',
              cursor: 'pointer',
              padding: '2px',
              backgroundColor: 'transparent',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '18px',
              minHeight: '18px',
              marginRight: '4px',
              '&:hover': {
                backgroundColor: 'action.hover',
              },
            }}
          >
            <Close sx={{ fontSize: '12px' }} />
          </Box>
        </Tooltip>
      )}
    </Box>
  </Box>
);
